import React, { useState, useEffect, useCallback, use } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormElement, FieldWrapper, Field } from "@progress/kendo-react-form";
import { Label, Error } from "@progress/kendo-react-labels";
import { TextArea } from "@progress/kendo-react-inputs";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { SchedulerFormEditor } from "@progress/kendo-react-scheduler";
import DocumentIcon from "@material-ui/icons/Description";
import "@progress/kendo-date-math/tz/all";
import { AvailabilityEditor } from "./custom-availability-editor";
import { Formik } from "formik";
import * as Yup from "yup";

import FormDataEntry from "../../pages/home/admin/FormDataEntry";
import {
  TitleEditor,
  TitleLabel,
  CustomEndEditor,
  StartTimezoneCheckedLabel,
  StartTimezoneCheckedEditor,
  DescriptionLabel,
  DescriptionEditor,
  ClientEditor,
  BookingLocationEditor,
  SessionTypeEditor,
  StatusEditor,
  BookingTypeEditor,
  EventTypeEditor,
  PaymentTypeEditor,
} from "./editors";
import { TextField, MenuItem, Grid, Select, Checkbox, makeStyles, Typography, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Button, Modal, Form, Row, Col, Tabs, Tab } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Admin from "../../store/ducks/admin.duck";
import * as Registration from "../../store/ducks/registration.duck";
import PlacesAutoComplete from "../AddressAutoComplete";
import { format, differenceInYears } from "date-fns";
import Notes from "../Notes";
import Files from "../Files";
import ClientScores from "../ClientScores";
import BookingBillingList from "../BookingBillingList";
import ReferralMaintenance from "../ReferralMaintenance";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const fieldLabels = {
  firstname: "Personal Tab - First Name",
  preferredname: "Personal Tab - Preferred Name",
  surname: "Personal Tab - Surname",
  dob: "Personal Tab - Date of Birth",
  email: "Personal Tab - Email",
  mobilephone: "Personal Tab - Mobile Phone",
  fulladdress: "Personal Tab - Address",
  pronouns: "Pronouns",

  emergencycontactname1: "Personal Tab - Emergency Contact Name",
  emergencycontactrelation1: "Personal Tab - Emergency Contact Relationship",
  emergencycontactphone1: "Personal Tab - Emergency Contact Phone",

  emergencycontactname2: "Personal Tab - Second Emergency Contact Name",
  emergencycontactrelation2: "Personal Tab - Second Emergency Contact Relationship",
  emergencycontactphone2: "Personal Tab - Second Emergency Contact Phone",
  hopeToGetFromTreatment: "Personal Tab - Hope to Get From Treatment",
  medicarereferenceno: "Personal Tab - Medicare Reference Number",
  medicareexpirydate: "Personal Tab - Medicare Expiry Date",
  medicareno: "Personal Tab - Medicare Card Number",

  ndisnumber: "Personal Tab - NDIS Number",
};

export const CustomFormEditor = (props) => {
  const { psychologistId } = props;
  const dispatch = useDispatch();
  const classes = useStyles();

  const registeredPsychologists = useSelector((state) => state.admin.RegisteredPsychologists);

  const registered =
    (psychologistId && registeredPsychologists && registeredPsychologists?.find((p) => p.id === psychologistId)) || registeredPsychologists?.[0];

  const providerType = registered?.providertype;
  const medicalPractitioners = useSelector((state) => state.admin.MedicalPractitioners);
  const medicalPractices = useSelector((state) => state.admin.MedicalPractices.GeneralPractitioner);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  const areasOfInterest = areasOfInterestReference.filter((area) => area.providertype === providerType);
  const client = useSelector((state) => state.admin.Client);
  const role = useSelector((state) => state.auth.roleDesc);
  const providerTemplates = useSelector((state) => state.admin.ProviderTemplates);
  const [formClient, setFormClient] = useState(null);

  // Email Duplicate Check
  const [emailIsDuplicate, setEmailIsDuplicate] = useState(false);
  const emailDuplicate = useSelector((state) => state.registration.EmailDuplicate);

  useEffect(() => {
    if (emailDuplicate === null || emailDuplicate === undefined) {
      return;
    }
    setEmailIsDuplicate(emailDuplicate === true);
    dispatch(Registration.actions.emailDuplicateClear());
  }, [emailDuplicate, dispatch]);

  useEffect(() => {
    props.valueGetter("clientID") &&
      dispatch(
        Admin.actions.fetchClient({
          clientID: props.valueGetter("clientID"),
          type: props.valueGetter("clienttype"),
        }),
      );
  }, [dispatch, props]);

  useEffect(() => {
    dispatch(Admin.actions.fetchCsAgents());
  }, [dispatch]);
  const csAgents = useSelector((state) => state.admin.CsAgents);

  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);
  const csCentres = useSelector((state) => state.admin.CsCentres);

  useEffect(() => {
    dispatch(Admin.actions.fetchPrograms());
  }, [dispatch]);

  useEffect(() => {
    dispatch(Admin.actions.fetchProviderTemplates());
  }, [dispatch]);

  const programs = useSelector((state) => state.admin.Programs);

  var [currentNoteViewType, setcurrentNoteViewType] = useState("NoteOnly");
  var [currentClientID, setcurrentClientID] = useState();
  var [currentMedicalPractitionerID, setcurrentMedicalPractitionerID] = useState();
  var [currentTimeZone, setcurrentTimeZone] = useState();
  var [currentID, setcurrentID] = useState();
  var [currentFirstName, setcurrentFirstName] = useState();
  var [currentPreferredName, setcurrentPreferredName] = useState();
  var [currentSurname, setcurrentSurname] = useState();
  var [currentDOB, setcurrentDOB] = useState();
  var [currentEmail, setcurrentEmail] = useState();
  var [currentMobile, setcurrentMobile] = useState();
  var [currentNote, setcurrentNote] = useState();
  var [currentClientProgram, setcurrentClientProgram] = useState();
  var [currentmedicareno, setcurrentmedicareno] = useState();
  var [currentmedicarereferenceno, setcurrentmedicarereferenceno] = useState();
  var [currentmedicareexpirydate, setcurrentmedicareexpirydate] = useState();
  var [currentAppointmentType, setcurrentAppointmentType] = useState("0");
  var [currentProviderType, setcurrentProviderType] = useState();
  var [currentABN, setcurrentABN] = useState();
  const [currentGPName, setcurrentGPName] = useState();
  const [currentReferralGPPracticeFax, setcurrentReferralGPPracticeFax] = useState();
  const [currentReferringGPName, setcurrentReferringGPName] = useState();
  const [currentReferringGPProviderNo, setcurrentReferringGPProviderNo] = useState();
  const [currentReferredGPOn, setcurrentReferredGPOn] = useState();
  const [currentProgramPopulation, setcurrentProgramPopulation] = useState([]);
  const [currentProgram, setcurrentProgram] = useState(false);
  const [currentContractProviderFee, setcurrentContractProviderFee] = useState();
  const [currentRHCContractManagedLabel, setcurrentRHCContractManagedLabel] = useState(false);
  const [currentNthQLDPHNPast, setcurrentNthQLDPHNPast] = useState();
  const [currentNthQLDPHNTotal, setcurrentNthQLDPHNTotal] = useState();
  const [currentNthQLDPHNFuture, setcurrentNthQLDPHNFuture] = useState();
  // Centralised Service Fields
  var [currentSpecialistType, setcurrentSpecialistType] = useState();
  var [currentCSCentre, setcurrentCSCentre] = useState();
  var [currentCSCentrePhone, setcurrentCSCentrePhone] = useState();
  var [currentCSCentreName, setcurrentCSCentreName] = useState();
  // Centralised Service Contact
  var [currentOwnerFirstName, setcurrentOwnerFirstName] = useState("");
  var [currentProviderTotal, setcurrentProviderTotal] = useState();

  var [show, setShow] = useState(false);
  var [showNotes, setShowNotes] = useState(false);
  var [showFiles, setShowFiles] = useState(false);
  var [showBookingBilling, setShowBookingBilling] = useState(false);
  const [showCancelProviderBooking, setShowCancelProviderBooking] = useState(false);
  const [cancellationReason, setCancellationReason] = useState();
  const [cancellationTypeSMSText, setCancellationTypeSMSText] = useState("");
  const [cancellationType, setCancellationType] = useState("");
  const [cancellationTypeSMS, setCancellationTypeSMS] = useState(false);
  const [booking, setBooking] = useState(false);

  var [noteAction, setNoteAction] = useState("SMS");
  var [key, setKey] = React.useState("Personal");

  // Define Program Question responses
  const programPopulationOptions = [
    {
      id: "1",
      index: "1",
      name: "Aboriginal and/or Torres Strait Islander",
    },
    {
      id: "2",
      index: "2",
      name: "Culturally and linguistically diverse",
    },
    {
      id: "3",
      index: "3",
      name: "Migrant and Refugee",
    },
    {
      id: "4",
      index: "4",
      name: "Under 20",
    },
    {
      id: "5",
      index: "5",
      name: "Rural and Remote",
    },
  ];

  const initMedicalPractitioner = () => {
    return {
      id: 0,
      providernumber: "",
      salutation: "Dr",
      firstName: "",
      surname: "",
      fullname: "",
      mobilephone: "",
      phone: "",
      type: "Client GP",
    };
  };

  const initMedicalPractice = () => {
    return {
      id: 0,
      abn: "",
      practicename: "",
      phone: "",
      address1: "",
      email: "",
      website: "",
      logoURL: "",
      practiceType: "GeneralPractitioner",
    };
  };

  const initCSCentre = () => {
    return {
      id: 0,
      cSCentreID: "",
      centerName: "",
      email: "",
      phone: "",
      contact: "",
      contactEmail: "",
      contactPhone: "",
    };
  };

  const initProgram = useCallback(() => {
    return {
      id: 0,
      name: "",
      identifier: "",
      description: "",
      status: "Active",
      aoi: 0,
      availabilitytype: "",
      bulkbilling: "N",
    };
  }, []);

  function getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1; // where the value doesn't exist
  }

  const providerVerbalConsent = (props) => {
    // Close Consent Form and Update Comment to Verbal Consent
    dispatch(
      Admin.actions.putAppointmentConsent({
        id: props.valueGetter("id"),
        refreshPayload: { key: "psychologist", id: registered.id },
      }),
    );
    // Change local state - taking the assumption it works - though it is fairly simple
    props.onChange("bulkBillingFormStatus", {
      value: "Verbal Consent Given",
    });
  };

  const providerResendConsent = (props) => {
    // Resent Consent Form to Client (if new) or if past close new and send past
    dispatch(
      Admin.actions.sendBulkBillingConsentForm({
        id: props.valueGetter("id"),
        days: props.valueGetter("days"),
        refreshPayload: { key: "psychologist", id: registered.id },
      }),
    );
  };

  const handleToggle = (value) => () => {
    const currentIndex = getIndex(value.id, currentProgramPopulation, "id"); //checked.find(r => r.id === value.id);
    const newChecked = [...currentProgramPopulation];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setcurrentProgramPopulation(newChecked);
  };

  const loadCSCentre = (thisCSCentre) => {
    setcurrentCSCentre(thisCSCentre ? thisCSCentre : initCSCentre());
    setcurrentCSCentrePhone(thisCSCentre ? thisCSCentre.contactPhone : "");
    setcurrentCSCentreName(thisCSCentre ? thisCSCentre.centerName : "");
  };

  const loadProgram = useCallback(
    (thisProgram) => {
      setcurrentClientProgram(thisProgram ? thisProgram : initProgram());
    },
    [initProgram],
  );

  const getProgramOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initProgram();
    }
  };

  const loadMedicalPractitioner = (thisMedicalPractitioner) => {
    setcurrentMedicalPractitioner(thisMedicalPractitioner ? thisMedicalPractitioner : initMedicalPractitioner());
    setcurrentMedicalPractitionerID(thisMedicalPractitioner ? thisMedicalPractitioner.id : 0);
    var tempMedicalPractice = thisMedicalPractitioner ? medicalPractices.find((v) => v.id === thisMedicalPractitioner.medicalPracticeID) : null;
    loadMedicalPractitice(tempMedicalPractice);
  };

  const loadMedicalPractitice = (thisMedicalPractice) => {
    setcurrentMedicalPractice(thisMedicalPractice ? thisMedicalPractice : initMedicalPractice());
  };

  function handleAppointmentTypeChange(value) {
    setcurrentAppointmentType(value);
  }

  function updateCancellationTypeSMS(value) {
    setCancellationTypeSMS(value);
  }

  var [currentMedicalPractitioner, setcurrentMedicalPractitioner] = useState(initMedicalPractitioner());
  var [currentMedicalPractice, setcurrentMedicalPractice] = useState(initMedicalPractice());

  const getMedicalPractitionerOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractitioner();
    }
  };

  const getMedicalPracticeOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractice();
    }
  };

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      setcurrentTimeZone(newValue.systemName);
    }
  }

  function cancelBooking(id) {
    // Need to handle no show which is triggered if it is save by a provider and reason is not selected - it is like the multiverse
    if (cancellationType === "NoShow") {
      // Update database as client did not show
      dispatch(
        Admin.actions.putAppointment({
          id: id,
          status: "NoShow",
          cancellationReason: cancellationReason,
          refreshPayload: { key: "psychologist", id: registered.id },
        }),
      );
      // Update local display
      setBooking({ ...booking, status: "NoShow" });
      if (cancellationTypeSMS && cancellationTypeSMSText && cancellationTypeSMSText.length > 10) {
        const formData = new FormData();
        formData.append("type", "Client");
        formData.append("pkid", booking.clientID);
        formData.append("subject", "");
        formData.append("selector", "SMS");
        formData.append("note", cancellationTypeSMSText);
        formData.append("faxdestination", "");
        formData.append("faxFile", "");
        formData.append("sendFormID", 0);
        // Ok Time to Dispatch
        process.env.REACT_APP_DEBUG && console.log(...formData);
        dispatch(
          Admin.actions.postNote({
            formData: formData,
            type: "Client",
            pkID: booking.clientID,
          }),
        );
      }
    } else {
      if (cancellationType === "LateCancel") {
        dispatch(
          Admin.actions.putAppointment({
            id: id,
            status: "LateCancel",
            cancellationReason: cancellationReason,
            refreshPayload: { key: "psychologist", id: registered.id },
          }),
        );
        // Update local display
        setBooking({ ...booking, status: "LateCancel" });
      } else {
        if (cancellationType === "LateCancelProvider") {
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "LateCancelProvider",
              cancellationReason: cancellationReason,
              refreshPayload: { key: props.type, id: props.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "LateCancelProvider" });
        } else {
          // Update database as booking cancelled by provider
          dispatch(
            Admin.actions.putAppointment({
              id: id,
              status: "Cancelled",
              cancellationReason: cancellationReason,
              refreshPayload: { key: "psychologist", id: registered.id },
            }),
          );
          // Update local display
          setBooking({ ...booking, status: "Cancelled" });
        }
      }
    }
    // Close provider booking cancel modal - if open
    setShowCancelProviderBooking(false);
  }

  function putClient(values) {
    console.log(values);
    const payload = {
      profileClientID: values.id,
      profileFirstName: values.firstname,
      profilePreferredName: values.preferredname,
      profileSurname: values.surname,
      profileDOB: values.dob,
      profileEmail: values.email,
      profileGender: values.gender,
      profileOccupation: values.occupation,
      profileMobile: values.mobilephone,
      profilefulladdress: values.fulladdress,
      profileStatus: values.status,
      profilepreviousstatus: values.previousstatus,
      profileNote: values.note,
      profilehopeToGetFromTreatment: values.hopeToGetFromTreatment,

      profileMedicalPractitionerID: values.medicalPractitionerID,
      profilePaymentType: values.paymentType,
      profileTimeZone: values.timeZone,
      profileLatitude: values.latitude,
      profileLongitude: values.longitude,
      profilePostCode: values.postCode,

      emergencycontactname1: values.emergencycontactname1,
      emergencycontactphone1: values.emergencycontactphone1,
      emergencycontactrelation1: values.emergencycontactrelation1,

      emergencycontactname2: values.emergencycontactname2,
      emergencycontactphone2: values.emergencycontactphone2,
      emergencycontactrelation2: values.emergencycontactrelation2,

      profilemedicareno: values.medicareno,
      profilemedicarereferenceno: values.medicarereferenceno,
      profilemedicareexpirydate: values.medicareexpirydate,

      profileAreasOfInterest: values.clientAreasOfInterest.map((aoi) => aoi.issue).join(","),

      medicalPractice: values.medicalPractice,
      medicalPractitioner: values.medicalPractitioner,

      status: values.status,
      appointmenttype: values.appointmenttype,

      profilegpname: values.gpName,
      profilegpclinicname: values.gpClinicName,

      profilendisnumber: values.ndisnumber,
      profilendisdatefrom: values.ndisdatefrom,
      profilendisdateto: values.ndisdateto,
      profilendisplanmanagementprovider: values.ndisplanmanagementprovider,
      profilendisdiagnosishistory: values.ndisdiagnosishistory,
      profilendisemailforinvoices: values.ndisemailforinvoices,
      profilendisbookingfee: values.ndisbookingfee,
      profileRHCNDISItemCode: values.rhcndisitemcode,
      profileNDISBillingNote: values.ndisbillingnote,

      profilepassword: null,
      profilepasswordconfirmation: null,

      profileConsentToShareWithGP: values.consentToShareWithGP,
      profilePronouns: values.pronouns,
      profileIndigenous: values.indigenous,

      profileNDISSupportCoordinator: values.ndissupportcoordinator,
      profileNDISSupportCoordinatorPhone: values.ndissupportcoordinatorphone,

      profileprogrampopulation: values.programpopulation.map((pp) => pp.name).join(","),

      profileNthQLDPHNBookings: values.nthQLDPHNEstimated,
    };

    dispatch(Admin.actions.putClientDetail(payload));
    setShow(false);
  }

  const loadProfile = useCallback(
    (thisClient, selectedTab) => {
      // Things needed to calculate/display related data
      const owner = csAgents.find((agent) => String(agent.id) === String(thisClient.owner));
      const csCentre = csCentres.find((v) => String(v.id) === String(thisClient.csCentreID));
      // Sort out the client's areas of interest based on the provider type
      const aoi_clienttype = areasOfInterestReference.filter((area) => area.providertype === providerType);
      const aoi = aoi_clienttype.filter(({ issue }) => thisClient.clientAreasOfInterest.includes(issue));
      // Sort out the client's program population based on the available options
      const programPopulation = programPopulationOptions.filter(({ name }) => thisClient.programpopulation.includes(name));
      const program = programs.find((v) => v.id === thisClient.programid);

      // Set variable to store client
      const preparedClient = {
        ...thisClient,
        clientAreasOfInterest: aoi,
        programpopulation: programPopulation,
        providerType: providerType,
        ownerName: owner ? owner.fullname : "",
        ownerEmail: owner ? owner.email : "",
        ownerPhone: owner ? owner.mobilephone : "",
        ownerFirstName: owner ? owner.firstname : "",
        program: program ? program : initProgram,
        csCentreName: csCentre ? csCentre.centerName : "",
        csCentrePhone: csCentre ? csCentre.phone : "",
        csCentreID: csCentre ? csCentre.id : null,
      };

      setFormClient(preparedClient);

      // Set a few parameters
      setcurrentOwnerFirstName(owner ? owner.firstname : "");

      // Go to the selected tab if provided
      if (selectedTab) {
        setKey(selectedTab);
      }

      setShow(true);
    },
    [areasOfInterestReference, providerType, csAgents, csCentres, programs, medicalPractitioners, loadMedicalPractitioner],
  );

  function loadBooking(props) {
    var bookingData = {
      id: props.valueGetter("id"),
      clientfullname: client.fullname,
      psychologistfullname: registered.fullname,
      psychologistDate: props.valueGetter("start"),
      clientID: client.id,
      paymentType: props.valueGetter("paymentType"),
      bookingType: props.valueGetter("bookingType"),
      sessionType: props.valueGetter("bookingCode"),
      bookingLocation: props.valueGetter("bookingLocation"),
    };
    setCancellationTypeSMSText(
      `Hello ${client && client.preferredname && client.preferredname.length > 0 ? client.preferredname : client.firstname}, We notice you did not attend your appointment with Rural Health Connect. We hope everything is OK. If you would like to discuss or reschedule please call us on 0493201005 or 0493432144 or your provider directly.`,
    );
    setBooking(bookingData);
    // Open Provider Cancel Modal
    setShowCancelProviderBooking(true);
  }

  function loadFiles(thisClient) {
    setcurrentClientID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    setShowFiles(true);
  }

  function loadNoteOnly(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentNoteViewType("NoteOnly");
    setcurrentSpecialistType(thisClient.specialisttype);
    setcurrentMobile(thisClient.mobilephone);
    setShowNotes(true);
  }

  function loadNotes(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentMobile(thisClient.mobilephone);
    setcurrentNoteViewType("CommunicationOnly");
    setShowNotes(true);
  }

  function loadBookingBilling(thisClient, noteAction) {
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    setcurrentDOB(thisClient.dob);
    setcurrentEmail(thisClient.email);
    setcurrentMobile(thisClient.mobilephone);
    setcurrentmedicareno(thisClient.medicareno);
    setcurrentmedicarereferenceno(thisClient.medicarereferenceno);
    setcurrentmedicareexpirydate(thisClient.medicareexpirydate);
    setcurrentReferringGPName(thisClient.referringGPName);
    setcurrentReferringGPProviderNo(thisClient.referringGPProviderNo);
    setcurrentReferredGPOn(thisClient.referredGPOn);
    setShowBookingBilling(true);
  }

  const initClient = {
    id: 0,
    firstname: "",
    preferredname: "",
    surname: "",
    dob: "",
    email: "",
    gender: "",
    occupation: "",
    mobilephone: "",
    fulladdress: "",
    status: "",
    previousstatus: "",
    note: "",
    hopeToGetFromTreatment: "",
    medicalPractitionerID: 0,
    paymentType: "",
    timeZone: "",
    latitude: "",
    longitude: "",
    postCode: "",
    emergencycontactname1: "",
    emergencycontactphone1: "",
    emergencycontactrelation1: "",
    emergencycontactname2: "",
    emergencycontactphone2: "",
    emergencycontactrelation2: "",
    medicareno: "",
    medicarereferenceno: "",
    medicareexpirydate: "",
    appointmenttype: "",
    gpName: "",
    gpClinicName: "",
    ndisnumber: "",
    ndisdatefrom: "",
    ndisdateto: "",
    ndisplanmanagementprovider: "",
    ndisdiagnosishistory: "",
    ndisemailforinvoices: "",
    ndisbookingfee: "",
    rhcndisitemcode: "",
    ndisbillingnote: "",
    consentToShareWithGP: "",
    pronouns: "",
    indigenous: "",
    ndissupportcoordinator: "",
    ndissupportcoordinatorphone: "",
    nthQLDPHNEstimated: "",
  };

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("First Name is required"),
    preferredname: Yup.string().max(200, "Too Long"),
    surname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("Surname is required"),
    dob: Yup.string().when(["providerType"], {
      is: (providerType) => providerType !== "Supervision",
      then: Yup.string()
        .required("Date of Birth is required")
        .test("dob", "Please enter a valid date", function (value) {
          return differenceInYears(new Date(), new Date(value)) >= 1 && differenceInYears(new Date(), new Date(value)) <= 100;
        }),
    }),
    email: Yup.string().when(["noEmail"], {
      is: (noEmail) => noEmail !== true,
      then: Yup.string()
        .min(2, "Too Short")
        .max(200, "Too Long")
        .email("Enter a valid email")
        .required("Email is required")
        .test("duplicate-email", "This email address is already registered", () => !emailIsDuplicate),
    }),
    mobilephone: Yup.string().min(2, "Too Short").max(12, "Too Long").required("Phone Number is required"),
    fulladdress: Yup.string().min(4, "Too Short").max(400, "Too Long").required("Address is required"),
    pronouns: Yup.string().max(20, "Too Long"),
    hopeToGetFromTreatment: Yup.string().max(4000, "Too Long"),
    emergencycontactname1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact  is required"),
      }),
    emergencycontactrelation1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(20, "Too Long").required("Emergency Contact Relationship is required"),
      }),
    emergencycontactphone1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      }),
    emergencycontactname2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("max-length", "Too Long", (value) => !value || value.length <= 100),
      }),

    emergencycontactrelation2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("max-length", "Too Long", (value) => !value || value.length <= 50),
      }),

    emergencycontactphone2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("min-length", "Too Short", (value) => !value || value.length >= 6)
          .test("max-length", "Too Long", (value) => !value || value.length <= 20),
      }),

    medicarereferenceno: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) => schema.matches(/^\d$/, "Must be 1 number").required("Medicare Reference Number is required"),
    }),

    medicareexpirydate: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurse", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) => schema.min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
    }),

    medicareno: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurse", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) =>
        schema
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => (value ? validateMedicareNumber(value) : false)),
    }),

    ndisnumber: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "NDIS",
      then: Yup.string().min(3, "Too Short").max(50, "Too Long").required("NDIS Number is required"),
    }),
  });

  const availabilityEventTypes = ["Availability", "Unavailable", "Supervision", "NthQLDPHN"];
  const eventType = props.valueGetter("eventType");
  const isAvailability = availabilityEventTypes.includes(eventType);
  const availabilityType = isAvailability ? eventType : "Availability";

  const getCommonAvailabilityProps = (props) => {
    const id = props.valueGetter("id");

    return {
      ...props,
      titleLabel: TitleLabel,
      titleEditor: TitleEditor,
      endEditor: !id ? CustomEndEditor : DateTimePicker,
      startTimezoneCheckedLabel: StartTimezoneCheckedLabel,
      startTimezoneCheckedEditor: StartTimezoneCheckedEditor,
      descriptionLabel: DescriptionLabel,
      descriptionEditor: DescriptionEditor,
      horizontal: true,
    };
  };

  useEffect(() => {
    if (isAvailability) {
      document.body.setAttribute("data-event-type", `availability-${availabilityType.toLowerCase()}`);
    } else {
      document.body.removeAttribute("data-event-type");
    }

    return () => {
      document.body.removeAttribute("data-event-type");
    };
  }, [isAvailability, availabilityType]);

  if (isAvailability) {
    return (
      <div className="modal-availability">
        <SchedulerFormEditor {...getCommonAvailabilityProps(props)} />

        <div className="availability-recurring-note availability-description-note">
          <strong>Note:</strong> Recurring availability without an end date will automatically be limited to 10 occurrences. To schedule availability beyond
          this limit, please set an end date or create another recurring series.
        </div>

        <div className="availability-settings-container">
          <AvailabilityEditor valueGetter={props.valueGetter} onChange={props.onChange} registered={registered} atype={availabilityType} />
        </div>
      </div>
    );
  }

  const renderBookingForm = (props) => {
    return (
      <FormElement horizontal={true} style={{ height: role !== "Admin" ? (!props.valueGetter("id") ? 460 : 560) : 460 }}>
        {!props.valueGetter("id") && (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Type</Label>
            <div className={"k-form-field-wrap"} style={{ width: 120 }}>
              <Field
                label="Type"
                name={"eventType"}
                component={EventTypeEditor}
                eapcontractndis={(registered && registered.eapContractNDISAvailability === "Y") || role === "Admin" ? true : false}
                // eapAvailability={(registered && registered.eapAvailability === "Y") || role === "Admin" ? true : false} - EAP only availability is being retired
                nthqldphn={registered && registered.specialisttype === "nthqldphn" ? true : false}
                supervisor={registered && registered.isSupervisor === "Y" ? true : false}
                centralisedservice={(registered && registered.specialisttype === "centralisedservice") || role === "Admin" ? true : false}
                centralisedservicePsychiatrist={(registered && registered.providertype === "Psychiatrist") || role === "Admin" ? true : false}
                admin={role === "Admin" ? true : false}
              />
              {props.visited && props.errors.eventType && <Error>{props.errors.eventType}</Error>}
            </div>
          </FieldWrapper>
        )}
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Start</Label>
          <div className="k-form-field-wrap">
            <Field name={"start"} component={DateTimePicker} rows={1} width={"200px"} format="dd/MM/yyyy hh:mm a" steps={{ minute: 15 }} />
          </div>
        </FieldWrapper>
        <FieldWrapper style={{ display: "flex" }}>
          <Label>End</Label>
          <div className="k-form-field-wrap">
            <Field
              name={"end"}
              component={!props.valueGetter("id") ? CustomEndEditor : DateTimePicker}
              as={DateTimePicker}
              eventType={props.valueGetter("eventType")}
              bookingCode={props.valueGetter("bookingCode")}
              start={props.valueGetter("start")}
              width={"200px"}
              rows={1}
              format="dd/MM/yyyy hh:mm a"
              steps={{ minute: 15 }}
            />{" "}
          </div>
        </FieldWrapper>
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Client</Label>
          <div className="k-form-field-wrap">
            <Field name={"clientID"} component={ClientEditor} disabled={props.valueGetter("id")} />
            {props.visited && props.errors.clientID && <Error>{props.errors.clientID}</Error>}
          </div>
        </FieldWrapper>
        {props.valueGetter("id") && (
          <FieldWrapper>
            <Label>Payment</Label>

            <div className="k-form-field-wrap">
              <Field name="paymentType" component={PaymentTypeEditor} client={client} />
              {props.visited && props.errors.paymentType && <Error>{props.errors.paymentType}</Error>}
            </div>
            {props.valueGetter("status") === "Active" &&
              registered &&
              registered.autoBulkBillingConsentForm === "Y" &&
              props.valueGetter("clientID") > 0 &&
              client.id > 0 &&
              client.specialisttype !== "centralisedservice" &&
              props.valueGetter("paymentType") === "Bulk Billed" &&
              props.valueGetter("bulkBillingFormStatus") !== "Completed" &&
              props.valueGetter("bulkBillingFormStatus") !== "Verbal Consent Given" &&
              props.valueGetter("id") > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    transform: "translateX(-60px)",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="success"
                    size="sm"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                      padding: "0.55rem 1rem",
                    }}
                    onClick={() => providerVerbalConsent(props)}
                  >
                    Verbal Consent
                  </Button>

                  <Button
                    variant="warning"
                    size="sm"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                      color: "#212529",
                      padding: "0.55rem 1rem",
                    }}
                    onClick={() => providerResendConsent(props)}
                  >
                    Resend Consent
                  </Button>
                </div>
              )}
          </FieldWrapper>
        )}
        <FieldWrapper style={{ display: "flex" }}>
          <Label>Note</Label>
          <div className="k-form-field-wrap">
            <Field name={"note"} component={TextArea} rows={2} />
          </div>
        </FieldWrapper>

        <FieldWrapper style={{ display: "flex" }}>
          <Label>Booking Type</Label>
          <div className="k-form-field-wrap">
            <Field
              name={"bookingType"}
              component={BookingTypeEditor}
              client={client}
              nthqldphn={
                registered &&
                registered.specialisttype === "nthqldphn" &&
                registered.facetoFaceBooking === "Y" &&
                client &&
                client.specialisttype === "nthqldphn"
                  ? true
                  : false
              }
            />
            {props.visited && props.errors.bookingType && <Error>{props.errors.bookingType}</Error>}
          </div>
        </FieldWrapper>

        {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
        props.valueGetter("clientID") > 0 &&
        client.id > 0 &&
        client.specialisttype === "centralisedservice" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Session Type</Label>
            <div className="k-form-field-wrap">
              <Field name={"bookingCode"} component={SessionTypeEditor} providerType={registered && registered.providertype} />
            </div>
          </FieldWrapper>
        ) : null}
        {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
        props.valueGetter("clientID") > 0 &&
        client.id > 0 &&
        client.specialisttype === "centralisedservice" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Location</Label>
            <div className="k-form-field-wrap" style={{ maxWidth: 120 }}>
              <Field name={"bookingLocation"} component={BookingLocationEditor} providerType={registered && registered.providertype} />
            </div>

            {props.valueGetter("bookingCode") === "P0101" || props.valueGetter("bookingCode") === "P0201" ? (
              <div className="k-form-field-wrap" style={{ maxWidth: 420 }}>
                <a
                  href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${providerTemplates.csAssessmentReportTemplateURL}`}
                  download
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#1976d2", // standard link blue (MUI-ish)
                    textDecoration: "underline",
                    fontWeight: 400,
                    marginLeft: 30,
                    marginTop: 5,
                  }}
                >
                  <DocumentIcon style={{ marginRight: 6, fontSize: 18 }} />
                  Diagnostic Assessment Report Template
                </a>
              </div>
            ) : null}
            {props.valueGetter("bookingCode") === "P0102" || props.valueGetter("bookingCode") === "P0202" ? (
              <div className="k-form-field-wrap" style={{ maxWidth: 420 }}>
                <a
                  href={`https://files.ruralhealthconnect.com.au/fileStoreRHC/${providerTemplates.csDischargeSummaryReportTemplateURL}`}
                  download
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#1976d2", // standard link blue (MUI-ish)
                    textDecoration: "underline",
                    fontWeight: 400,
                    marginLeft: 30,
                    marginTop: 5,
                  }}
                >
                  <DocumentIcon style={{ marginRight: 6, fontSize: 18 }} />
                  Discharge Summary Report Template
                </a>
              </div>
            ) : null}
          </FieldWrapper>
        ) : null}

        <FieldWrapper style={{ display: "flex" }}>
          <Label>Status</Label>
          <div className="k-form-field-wrap" style={{ maxWidth: 190 }}>
            <Field name={"status"} component={StatusEditor} />
          </div>
          {(props.valueGetter("status") === "Active" || props.valueGetter("status") === "Attended") &&
          props.valueGetter("clientID") > 0 &&
          client.id > 0 &&
          client.specialisttype !== "centralisedservice" &&
          props.valueGetter("id") > 0 ? (
            <div className="k-form-field-wrap" style={{ maxWidth: 220 }}>
              <Button
                variant="secondary"
                size="sm"
                style={{
                  color: "black",
                  fontWeight: 500,
                  border: "1px solid rgb(192 192 192)",
                  background: "#faa0a0",
                  marginLeft: 30,
                  marginRight: 10,
                }}
                onClick={() => loadBooking(props)}
              >
                Cancel Booking
              </Button>
            </div>
          ) : null}
        </FieldWrapper>
        {props.valueGetter("clientID") > 0 && client.id > 0 && role !== "Admin" ? (
          <FieldWrapper style={{ display: "flex" }}>
            <Label>Actions</Label>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#b2b6eb",
                marginRight: 10,
              }}
              onClick={() => loadProfile(client)}
            >
              Profile
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#ede9fe",
                marginRight: 10,
              }}
              onClick={() => loadNoteOnly(client, "Note")}
            >
              Notes
            </Button>

            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#faefcf",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "SMS")}
            >
              SMS
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#d2f9fa",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Email")}
            >
              Email
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#ebfae8",
                marginRight: 10,
              }}
              onClick={() => loadFiles(client)}
            >
              Files
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#fff0ed",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Fax")}
            >
              Fax
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#fffbc2",
                marginRight: 10,
              }}
              onClick={() => loadNotes(client, "Form")}
            >
              Forms
            </Button>
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#FF9636",
                marginRight: 10,
              }}
              onClick={() => loadBookingBilling(client)}
            >
              Billing
            </Button>
          </FieldWrapper>
        ) : (
          <FieldWrapper style={{ display: "flex" }}></FieldWrapper>
        )}

        <Modal show={showNotes} onHide={() => setShowNotes(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              {currentNoteViewType === "CommunicationOnly" ? "Communications" : "Notes"} - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? (
              <Notes
                type="Client"
                ownerName={currentOwnerFirstName}
                specialistType={currentSpecialistType}
                noteAction={noteAction}
                pkid={currentClientID}
                firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
                faxGP={currentReferralGPPracticeFax}
                medicalPractice={currentMedicalPractice}
                waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                psychologistFullName={registered.firstname + " " + registered.surname}
                clientFirstName={currentFirstName}
                email={currentEmail}
                mobilephone={currentMobile}
                providerTotal={currentProviderTotal}
                viewType={currentNoteViewType}
              />
            ) : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowNotes(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showFiles} onHide={() => setShowFiles(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              Files - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? <Files type="Client" pkid={currentClientID} specialistType={currentSpecialistType} /> : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowFiles(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showBookingBilling} onHide={() => setShowBookingBilling(false)} dialogClassName="notes-modal-dialog" style={{ zIndex: 1150 }}>
          <Modal.Header closeButton className="notes-modal">
            <Modal.Title>
              Billing - {currentFirstName} {currentSurname}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="notes-modal">
            {registered ? (
              <BookingBillingList
                id={currentClientID}
                clientFirstName={currentFirstName}
                clientSurname={currentSurname}
                clientDOB={currentDOB}
                clientEmail={currentEmail}
                clientMobile={currentMobile}
                clientMedicareNo={currentmedicareno}
                clientMedicareReferenceNo={currentmedicarereferenceno}
                clientMedicareExpiryDate={currentmedicareexpirydate}
                clientreferringGPName={currentReferringGPName}
                clientreferringGPProviderNo={currentReferringGPProviderNo}
                clientreferredOn={currentReferredGPOn}
              />
            ) : null}
          </Modal.Body>
          <Modal.Footer className="notes-modal">
            <Button variant="secondary" onClick={() => setShowBookingBilling(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={show} onHide={() => setShow(false)} dialogClassName="editprofile-modal" style={{ zIndex: 1150 }}>
          <Formik
            enableReinitialize={true}
            initialValues={formClient || initClient}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              putClient(values);
              // actions.setSubmitting(false);
            }}
          >
            {(props) => {
              const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
              const change = (name, e) => {
                e.persist();
                handleChange(e);
              };

              return (
                <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                  <Modal.Header closeButton className="editprofile-modal">
                    <Modal.Title>
                      Edit Profile - {values.firstname} {values.surname}
                      {currentRHCContractManagedLabel ? (
                        <span style={{ marginLeft: 40, color: "blue" }}>Managed by RHC. Provider payment per session ${currentContractProviderFee}</span>
                      ) : null}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="editprofile-modal">
                    <Tabs id="EditModal" activeKey={key} onSelect={(k) => setKey(k)} mountOnEnter={true}>
                      <Tab eventKey="Personal" title="Personal" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        {values.specialisttype === "centralisedservice" ? (
                          <>
                            <Row>
                              <h5 style={{ marginBottom: "25px" }}>Centralised Service Information</h5>
                            </Row>
                            <Row style={{ marginBottom: "20px" }}>
                              <Col md="3">
                                <div className="text">Estimated End of Care Date</div>
                                <div style={{ fontSize: "1.1rem" }}>{values.estimatedEndOfCareDate || "-"}</div>
                              </Col>
                              <Col md="3">
                                <div className="text">Future Sessions</div>
                                <div style={{ fontSize: "1.1rem" }}>{values.futureSessions ?? "-"}</div>
                              </Col>
                              <Col md="3">
                                <div className="text">Attended Bookings</div>
                                <div style={{ fontSize: "1.1rem" }}>{values.attendedSessions ?? "-"}</div>
                              </Col>
                              <Col md="3">
                                <div className="text">Cancelled Bookings</div>
                                <div style={{ fontSize: "1.1rem" }}>{values.cancelledSessions ?? "-"}</div>
                              </Col>
                            </Row>{" "}
                            <Row>
                              <Col md="6">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Centre contact</Form.Label>
                                  <Form.Control type="text" name="ownerName" value={values.ownerName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Contact Email</Form.Label>
                                  <Form.Control type="text" name="ownerEmail" value={values.ownerEmail} readOnly style={{ backgroundColor: "#e9ecef" }} />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Contact Phone</Form.Label>
                                  <Form.Control type="text" name="ownerPhone" value={values.ownerPhone} readOnly style={{ backgroundColor: "#e9ecef" }} />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Centre</Form.Label>
                                  <Form.Control type="text" name="csCentreName" value={values.csCentreName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Centre Phone</Form.Label>
                                  <Form.Control type="text" name="csCentrePhone" value={values.csCentrePhone} readOnly style={{ backgroundColor: "#e9ecef" }} />
                                </Form.Group>
                              </Col>
                            </Row>
                            <hr />
                          </>
                        ) : null}
                        <Row>
                          <h5 style={{ marginTop: "20px", marginBottom: "25px" }}>Personal Information</h5>
                        </Row>

                        <Row>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>First Name*</Form.Label>
                              <Form.Control
                                type="text"
                                name="firstname"
                                value={values.firstname}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.firstname && !!errors.firstname}
                                isValid={touched.firstname && !errors.firstname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Preferred Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="preferredname"
                                value={values.preferredname}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.preferredname && !!errors.preferredname}
                                isValid={touched.preferredname && !errors.preferredname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.preferredname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Surname*</Form.Label>
                              <Form.Control
                                type="text"
                                name="surname"
                                value={values.surname}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.surname && !!errors.surname}
                                isValid={touched.surname && !errors.surname}
                              />
                              <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Pronouns</Form.Label>
                              <Form.Control
                                type="text"
                                name="pronouns"
                                value={values.pronouns}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.pronouns && !!errors.pronouns}
                                isValid={touched.pronouns && !errors.pronouns}
                              />
                              <Form.Control.Feedback type="invalid">{errors.pronouns}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          {currentProviderType !== "Supervision" ? (
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Gender*</Form.Label>
                                <Form.Control as="select" name="gender" value={values.gender} onChange={handleChange}>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                  <option value="Prefer not to say">Prefer not to say</option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                          ) : null}
                          {currentProviderType !== "Supervision" ? (
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Date of Birth*</Form.Label>
                                <Form.Control
                                  type="date"
                                  name="dob"
                                  value={values.dob}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.dob && !!errors.dob}
                                  isValid={touched.dob && !errors.dob}
                                />
                                <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          ) : null}
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>TimeZone*</Form.Label>
                              <Autocomplete
                                id="profileTimeZone"
                                variant="outlined"
                                options={timeZone}
                                getOptionLabel={(option) => option.name}
                                value={timeZone.find((v) => v.systemName === values.timeZone) || ""}
                                onChange={(event, newValue) => setFieldValue("timeZone", newValue ? newValue.systemName : "")}
                                style={{
                                  fullWidth: true,
                                  display: "flex",
                                  wrap: "nowrap",
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    type="text"
                                    variant="outlined"
                                    margin="dense"
                                    name="TimeZoneSelector"
                                    style={{
                                      backgroundColor: "white",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                    inputProps={{
                                      ...params.inputProps,
                                      autoComplete: "new-password",
                                    }}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Email * </Form.Label>
                              <Form.Control
                                type="text"
                                name="email"
                                value={values.email}
                                onChange={(e) => {
                                  setEmailIsDuplicate(false);
                                  change("email", e);
                                }}
                                onBlur={(e) => {
                                  handleBlur(e);
                                  if (e.currentTarget.value && e.currentTarget.value.length > 0) {
                                    dispatch(
                                      Registration.actions.emailDuplicate({ emailAddress: e.currentTarget.value, checkType: "client", clientId: values.id }),
                                    );
                                  }
                                }}
                                isInvalid={touched.email && !!errors.email}
                                isValid={touched.email && !errors.email}
                                autoComplete="new-password"
                              />
                              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>{" "}
                            </Form.Group>
                          </Col>

                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Contact Phone Number*</Form.Label>
                              <Form.Control
                                type="text"
                                name="mobilephone"
                                value={values.mobilephone}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.mobilephone && !!errors.mobilephone}
                                isValid={touched.mobilephone && !errors.mobilephone}
                              />
                              <Form.Control.Feedback type="invalid">{errors.mobilephone}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Home Address (start typing to search) *</Form.Label>
                              <PlacesAutoComplete
                                currentID={values.id}
                                currentfulladdress={values.fulladdress}
                                setcurrentfulladdress={(value) => {
                                  setFieldValue("fulladdress", value, true);
                                  setFieldTouched("fulladdress", true, true);
                                }}
                                setcurrentLatitude={(value) => setFieldValue("latitude", value)}
                                setcurrentLongitude={(value) => setFieldValue("longitude", value)}
                                setcurrentPostCode={(value) => setFieldValue("postCode", value)}
                                isInvalid={touched.fulladdress && !!errors.fulladdress}
                                isValid={touched.fulladdress && !errors.fulladdress}
                              />
                              {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                            </Form.Group>
                          </Col>
                          {values.providerType !== "Supervision" && values.specialisttype !== "centralisedservice" ? (
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Occupation</Form.Label>
                                <Form.Control type="text" name="occupation" value={values.occupation} onChange={handleChange} autoComplete="new-password" />
                              </Form.Group>
                            </Col>
                          ) : null}
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Do you identify as Aboriginal and/or Torres Strait islander</Form.Label>
                              <Form.Control as="select" name="indigenous" value={values.indigenous} onChange={handleChange}>
                                <option value="N">No</option>
                                <option value="Y">Yes</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          {values.providerType !== "Financial" && values.providerType !== "Supervision" ? (
                            <>
                              <Col md="3">
                                <Form.Group style={{ width: "100%" }}>
                                  <Form.Label>Funding Type*</Form.Label>
                                  {values.specialisttype === "centralisedservice" ? (
                                    <Form.Control
                                      type="text"
                                      name="paymentType"
                                      value={values.paymentType || ""}
                                      readOnly
                                      style={{
                                        backgroundColor: "#e9ecef",
                                        cursor: "default",
                                      }}
                                    />
                                  ) : (
                                    <Form.Control as="select" name="paymentType" value={values.paymentType} onChange={handleChange}>
                                      <option value="Bulk Billed">Bulk Billed</option>
                                      <option value="Reduced Gap">Reduced Gap</option>
                                      <option value="Full Fee">Full Fee</option>
                                      <option value="NDIS">NDIS</option>
                                      <option value="Contract" disabled>
                                        Contract
                                      </option>
                                      <option value="EAP" disabled>
                                        EAP
                                      </option>
                                      <option value="TAC" disabled>
                                        Transport Accident Commmission
                                      </option>
                                      <option value="WorkCover" disabled>
                                        Work Cover
                                      </option>
                                      <option value="DVA" disabled>
                                        Department of Veterans` Affairs
                                      </option>
                                      <option value="Island">Island (Cocos and Christmas Islands)</option>
                                    </Form.Control>
                                  )}
                                </Form.Group>
                              </Col>{" "}
                              {values.paymentType === "Contract" ? (
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Specialist Type</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={values.specialisttype === "centralisedservice" ? "Centralised Service" : values.specialisttype}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef" }}
                                    />
                                  </Form.Group>
                                </Col>
                              ) : null}
                              {values.specialisttype !== "centralisedservice" ? (
                                <>
                                  <Col md="6">
                                    <Form.Group style={{ width: "100%" }}>
                                      <Form.Label>Program (Set by RHC Admin)</Form.Label>
                                      <Autocomplete
                                        id="ProgramID"
                                        variant="outlined"
                                        options={programs}
                                        getOptionLabel={(option) => option.name}
                                        getOptionSelected={(option, value) => getProgramOption(option, value)}
                                        value={values.program}
                                        style={{
                                          fullWidth: true,
                                          display: "flex",
                                          wrap: "nowrap",
                                          cursor: "default",
                                          backgroundColor: "#e9ecef",
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            type="text"
                                            variant="outlined"
                                            margin="dense"
                                            name="programID"
                                            style={{
                                              backgroundColor: "",
                                              margin: 0,
                                              padding: 0,
                                            }}
                                            inputProps={{
                                              ...params.inputProps,
                                              autoComplete: "new-password",
                                            }}
                                            disabled
                                          />
                                        )}
                                      />
                                    </Form.Group>
                                  </Col>
                                </>
                              ) : null}
                            </>
                          ) : null}
                          {values.paymentType === "Contract" || values.paymentType === "EAP" ? (
                            <Col md="2">
                              <Form.Group>
                                <Form.Label>Contract Provider Fee</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="contractproviderfee"
                                  value={values.contractproviderfee}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                              </Form.Group>
                            </Col>
                          ) : null}
                        </Row>
                        {values.specialisttype === "centralisedservice" ? (
                          <>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Translator Required</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={values.translator || ""}
                                    readOnly
                                    style={{
                                      backgroundColor: "#e9ecef",
                                      cursor: "default",
                                    }}
                                  />
                                </Form.Group>
                              </Col>{" "}
                              {values.translator === "Yes" ? (
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Language</Form.Label>
                                    <Form.Control type="text" name="profiletranslatorLanguage" value={values.translatorLanguage} readOnly />
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Support Person Required *</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={values.supportPerson || ""}
                                    readOnly
                                    style={{
                                      backgroundColor: "#e9ecef",
                                      cursor: "default",
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              {values.supportPerson === "Yes" ? (
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Type of support person</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="profilesupportPersonDetail"
                                      value={values.profilesupportPersonDetail}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                    />
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                          </>
                        ) : null}
                        {values.paymentType === "Contract" || values.paymentType === "EAP" ? (
                          <>
                            {values.specialisttype === "nthqldphn" ? (
                              <>
                                <Row>
                                  <Col md="12">
                                    <Form.Label style={{ color: "green", fontWeight: 500 }}>Nth QLD PHN Booking Management for this client</Form.Label>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="2">
                                    <Form.Group>
                                      <Form.Label>Estimated Total</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="nthQLDPHNEstimated"
                                        value={values.nthQLDPHNEstimated}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="2">
                                    <Form.Group>
                                      <Form.Label>Total To Date</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="profileNthQLDPHNTotal"
                                        defaultValue={currentNthQLDPHNTotal}
                                        readOnly
                                        style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="2">
                                    <Form.Group>
                                      <Form.Label>Past Bookings</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="profileNthQLDPHNPast"
                                        defaultValue={currentNthQLDPHNPast}
                                        readOnly
                                        style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="2">
                                    <Form.Group>
                                      <Form.Label>Future Bookings</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="profileNthQLDPHNFuture"
                                        defaultValue={currentNthQLDPHNFuture}
                                        readOnly
                                        style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </>
                            ) : null}
                          </>
                        ) : null}
                        {programPopulationOptions && currentProgram ? (
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>
                                  Do you identify as any of the following populations that we are particularly supporting via this program? (select all that
                                  apply)
                                </Form.Label>
                                <Row>
                                  <Col md="6">
                                    <List className={classes.root}>
                                      {programPopulationOptions.map((row) => {
                                        if (row.index <= programPopulationOptions.length / 2) {
                                          const labelId = `checkbox-list-label-${row.id}`;
                                          var isChecked = (values.programPopulation || []).find((r) => r.id === row.id);
                                          return (
                                            <ListItem
                                              key={row.id}
                                              role={undefined}
                                              dense
                                              button
                                              onClick={() => {
                                                const current = values.programPopulation || [];
                                                const exists = current.some((r) => r.id === row.id);
                                                setFieldValue("programPopulation", exists ? current.filter((r) => r.id !== row.id) : [...current, row]);
                                              }}
                                            >
                                              <ListItemIcon style={{ minWidth: 40 }}>
                                                <Checkbox
                                                  edge="start"
                                                  checked={isChecked !== undefined}
                                                  tabIndex={-1}
                                                  disableRipple
                                                  inputProps={{
                                                    "aria-labelledby": labelId,
                                                  }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText
                                                id={labelId}
                                                style={{ fontSize: 12 }}
                                                disableTypography
                                                primary={
                                                  <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                                }
                                                className={classes.link}
                                              />
                                            </ListItem>
                                          );
                                        } else {
                                          return null;
                                        }
                                      })}
                                    </List>
                                  </Col>
                                  <Col md="6">
                                    <List className={classes.root}>
                                      {programPopulationOptions.map((row) => {
                                        if (row.index > programPopulationOptions.length / 2) {
                                          const labelId = `checkbox-list-label-${row.id}`;
                                          var isChecked = (values.programPopulation || []).find((r) => r.id === row.id);
                                          return (
                                            <ListItem
                                              key={row.id}
                                              role={undefined}
                                              dense
                                              button
                                              onClick={() => {
                                                const current = values.programPopulation || [];
                                                const exists = current.some((r) => r.id === row.id);
                                                setFieldValue("programPopulation", exists ? current.filter((r) => r.id !== row.id) : [...current, row]);
                                              }}
                                            >
                                              <ListItemIcon style={{ minWidth: 40 }}>
                                                <Checkbox
                                                  edge="start"
                                                  checked={isChecked !== undefined}
                                                  tabIndex={-1}
                                                  disableRipple
                                                  inputProps={{
                                                    "aria-labelledby": labelId,
                                                  }}
                                                />
                                              </ListItemIcon>
                                              <ListItemText
                                                id={labelId}
                                                style={{ fontSize: 12 }}
                                                disableTypography
                                                primary={
                                                  <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                                }
                                                className={classes.link}
                                              />
                                            </ListItem>
                                          );
                                        } else {
                                          return null;
                                        }
                                      })}
                                    </List>
                                  </Col>
                                </Row>
                              </Form.Group>
                            </Col>
                          </Row>
                        ) : null}
                        {values.providerType !== "GP" && values.providerType !== "Supervision" && values.specialisttype !== "centralisedservice" ? (
                          <>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Areas of Interest (Select all that apply) </Form.Label>
                                  <Autocomplete
                                    id="searchAOI"
                                    variant="outlined"
                                    multiple
                                    options={areasOfInterest}
                                    getOptionLabel={(option) => option.issue}
                                    value={values.clientAreasOfInterest || []}
                                    onChange={(event, newValue) => setFieldValue("clientAreasOfInterest", newValue)}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                      backgroundColor: "white",
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        type="text"
                                        variant="outlined"
                                        margin="dense"
                                        name="AOISelector"
                                        style={{
                                          backgroundColor: "",
                                          margin: 0,
                                          padding: 0,
                                        }}
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete: "new-password",
                                        }}
                                      />
                                    )}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                        {values.specialisttype !== "centralisedservice" ? (
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                {values.providerType !== "Supervision" ? (
                                  <>
                                    <Form.Label>What are you hoping to get out of your sessions?</Form.Label>
                                  </>
                                ) : (
                                  <Form.Label>
                                    Details on the type of supervision you are after, where you are currently practicing and other relevant information.
                                  </Form.Label>
                                )}
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="hopeToGetFromTreatment"
                                  value={values.hopeToGetFromTreatment}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        ) : null}
                        {values.handOverNotes && values.handOverNotes.length > 2 ? (
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Handover Notes </Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="profilehandOverNotes"
                                  readOnly
                                  defaultValue={values.handOverNotes}
                                  style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        ) : null}
                        {/* <Row>
                    <Col md="10">
                      <Form.Group controlId="currentMedicalPractitioner.address">
                        <Form.Label>Address - may need to add this </Form.Label>
                          <Form.Control type="text" name="address" value={currentMedicalPractitioner ? currentMedicalPractitioner.address : ''} readOnly />
                      </Form.Group>
                    </Col>
                  </Row> */}
                        {currentProviderType === "Financial" ? (
                          <>
                            <Row>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Business Name</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="businessName"
                                    readOnly
                                    value={values.businessName || ""}
                                    style={{ backgroundColor: "#e9ecef" }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>ABN</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="abn"
                                    readOnly
                                    value={values.abn || ""}
                                    style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Business Address</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="businessAddress"
                                    readOnly
                                    value={values.businessAddress || ""}
                                    style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>Background Information</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    readOnly
                                    name="backgroundinformation"
                                    value={values.backgroundInformation}
                                    autoComplete="new-password"
                                    style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}

                        {currentProviderType !== "Financial" && currentProviderType !== "Supervision" ? (
                          <>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Emergency Contact 1*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactname1"
                                    value={values.emergencycontactname1 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactname1 && !!errors.emergencycontactname1}
                                    isValid={touched.emergencycontactname1 && !errors.emergencycontactname1}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactname1}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Relationship*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactrelation1"
                                    value={values.emergencycontactrelation1 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactrelation1 && !!errors.emergencycontactrelation1}
                                    isValid={touched.emergencycontactrelation1 && !errors.emergencycontactrelation1}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation1}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Phone*</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactphone1"
                                    value={values.emergencycontactphone1 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactphone1 && !!errors.emergencycontactphone1}
                                    isValid={touched.emergencycontactphone1 && !errors.emergencycontactphone1}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactphone1}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Emergency Contact 2</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactname2"
                                    value={values.emergencycontactname2 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactname2 && !!errors.emergencycontactname2}
                                    isValid={touched.emergencycontactname2 && !errors.emergencycontactname2}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactname2}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Relationship</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactrelation2"
                                    value={values.emergencycontactrelation2 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactrelation2 && !!errors.emergencycontactrelation2}
                                    isValid={touched.emergencycontactrelation2 && !errors.emergencycontactrelation2}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation2}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="4">
                                <Form.Group>
                                  <Form.Label>Phone</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="emergencycontactphone2"
                                    value={values.emergencycontactphone2 || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.emergencycontactphone2 && !!errors.emergencycontactphone2}
                                    isValid={touched.emergencycontactphone2 && !errors.emergencycontactphone2}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.emergencycontactphone2}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}
                        {values.paymentType === "NDIS" ? (
                          <>
                            <h5 style={{ paddingBottom: 20 }}>Billing Information</h5>
                            <Row>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>NDIS Number</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndisnumber"
                                    value={values.ndisnumber || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                    isInvalid={touched.ndisnumber && !!errors.ndisnumber}
                                    isValid={touched.ndisnumber && !errors.ndisnumber}
                                  />
                                  <Form.Control.Feedback type="invalid">{errors.ndisnumber}</Form.Control.Feedback>
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>NDIS Date From</Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="ndisdatefrom"
                                    value={values.ndisdatefrom}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>To</Form.Label>
                                  <Form.Control type="date" name="ndisdateto" value={values.ndisdateto} onChange={handleChange} autoComplete="new-password" />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>NDIS Total Fee</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndisbookingfee"
                                    value={values.ndisbookingfee || ""}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>NDIS Plan Management Provider</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndisplanmanagementprovider"
                                    value={values.ndisplanmanagementprovider}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>NDIS Invoice Email</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndisemailforinvoices"
                                    value={values.ndisemailforinvoices}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>NDIS Support Coordinator</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndissupportcoordinator"
                                    value={values.ndissupportcoordinator}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>NDIS Support Coordinator Phone</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="ndissupportcoordinatorphone"
                                    value={values.ndissupportcoordinatorphone}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>NDIS Item Code</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="rhcndisitemcode"
                                    value={values.rhcndisitemcode}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <Form.Group>
                                  <Form.Label>NDIS Billing Note</Form.Label>
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    type="text"
                                    name="ndisbillingnote"
                                    value={values.ndisbillingnote}
                                    onChange={handleChange}
                                    autoComplete="new-password"
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                          </>
                        ) : null}

                        {currentProviderType !== "Financial" ? (
                          <>
                            <Row>
                              {values.paymentType !== "Contract" &&
                              values.paymentType !== "NDIS" &&
                              values.paymentType !== "EAP" &&
                              currentProviderType !== "Supervision" ? (
                                <>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Medicare Card Number</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="medicareno"
                                        value={values.medicareno || ""}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                        isInvalid={touched.medicareno && !!errors.medicareno}
                                        isValid={touched.medicareno && !errors.medicareno}
                                      />
                                      <Form.Control.Feedback type="invalid">{errors.medicareno}</Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Order on Card</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="medicarereferenceno"
                                        value={values.medicarereferenceno || ""}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                        isInvalid={touched.medicarereferenceno && !!errors.medicarereferenceno}
                                        isValid={touched.medicarereferenceno && !errors.medicarereferenceno}
                                      />
                                      <Form.Control.Feedback type="invalid">{errors.medicarereferenceno}</Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Medicare Expiry Date</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="medicareexpirydate"
                                        value={values.medicareexpirydate || ""}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                        isInvalid={touched.medicareexpirydate && !!errors.medicareexpirydate}
                                        isValid={touched.medicareexpirydate && !errors.medicareexpirydate}
                                      />
                                      <Form.Control.Feedback type="invalid">{errors.medicareexpirydate}</Form.Control.Feedback>
                                    </Form.Group>
                                  </Col>
                                </>
                              ) : null}
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Appointment Type</Form.Label>
                                  <Select
                                    variant="outlined"
                                    margin="dense"
                                    id="appointmentType"
                                    aria-label="Select Appointment Type"
                                    name="appointmentType"
                                    value={values.appointmenttype}
                                    onChange={(event) => setFieldValue("appointmenttype", event.target.value)}
                                    style={{
                                      fullWidth: true,
                                      display: "flex",
                                      wrap: "nowrap",
                                      backgroundColor: "#fff",
                                    }}
                                  >
                                    <MenuItem key="Video" value="0">
                                      Video Call
                                    </MenuItem>
                                    <MenuItem key="Phone" value="1">
                                      Phone Call
                                    </MenuItem>
                                  </Select>
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Client Status</Form.Label>
                                  <Form.Control type="text" value={values.status} readOnly style={{ backgroundColor: "#e9ecef", cursor: "default" }} />
                                </Form.Group>
                              </Col>

                              {values.specialisttype === "centralisedservice" ? (
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Centralised Service Status</Form.Label>
                                    <Form.Control
                                      type="text"
                                      value={values.closureProviderStatus || "Active"}
                                      readOnly
                                      style={{
                                        backgroundColor: "#e9ecef",
                                        cursor: "default",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                              ) : null}
                            </Row>
                            {values.specialisttype !== "centralisedservice" && (
                              <>
                                <h5 style={{ paddingBottom: 20 }}>Registration Questions and Responses</h5>
                                <Row>
                                  <Col md="6">
                                    <Form.Group>
                                      <Form.Label>
                                        Have you received a Mental Health Plan in the last 12 Months ?
                                        <span style={{ fontStyle: "italic", fontWeight: 600 }}>
                                          (Note this question is only answered if the client registered for a GP booking - originally)
                                        </span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="gpmentalhealthplan12months"
                                        readOnly
                                        style={{ width: "25%", backgroundColor: "#e9ecef", cursor: "default" }}
                                        value={values.gpmentalhealthplan12months || ""}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                {values.paymentType === "Bulk Billed" || values.paymentType === "Reduced Gap" ? (
                                  <>
                                    {values.paymentType === "Bulk Billed" ? (
                                      <>
                                        <Form.Label style={{ fontStyle: "italic", fontWeight: 600 }}>
                                          Note: The questions below no longer appear in the Client Registration Form but are still in the Database for older
                                          clients.{" "}
                                        </Form.Label>
                                        <Row>
                                          <Col md="3">
                                            <Form.Group>
                                              <Form.Label>Do you have a Health Care Card?</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="healthcarecard"
                                                readOnly
                                                value={values.healthcarecard || ""}
                                                style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col md="3">
                                            <Form.Group>
                                              <Form.Label>Are you Unemployed?</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="unemployed"
                                                readOnly
                                                value={values.unemployed || ""}
                                                style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                              />
                                            </Form.Group>
                                          </Col>
                                          <Col md="6">
                                            <Form.Group>
                                              <Form.Label>Have you been impacted by drought, bushfire, flood or other natural disaster?</Form.Label>
                                              <Form.Control
                                                type="text"
                                                name="naturaldisaster"
                                                readOnly
                                                value={values.naturaldisaster || ""}
                                                style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                              />
                                            </Form.Group>
                                          </Col>
                                        </Row>
                                      </>
                                    ) : null}
                                    <Row>
                                      <Col md="12">
                                        <Form.Group>
                                          <Form.Label>Please tell us why you need to be bulk billed (or reduced fee)?</Form.Label>
                                          <Form.Control
                                            as="textarea"
                                            rows={4}
                                            type="text"
                                            readOnly
                                            name="bulkbilledreason"
                                            value={values.bulkbilledreason || ""}
                                            style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                            autoComplete="new-password"
                                          />
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                  </>
                                ) : null}
                              </>
                            )}
                          </>
                        ) : null}
                      </Tab>
                      {values.specialisttype === "centralisedservice" ? (
                        <Tab eventKey="CSReferral" title="CS Referral" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                          <h5>Referral Information</h5>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Purpose of referral *</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="referralPurpose"
                                  value={values.referralPurpose}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  What would the consumer like to achieve through this referral?
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Presenting concerns & relevant background*</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="hopeToGetFromTreatment"
                                  value={values.hopeToGetFromTreatment}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  Please provide details that support collaborative care, such as frequency of case conferences, support needs, etc. If referral
                                  information is described in the IAR please refer to it.
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Current Medication</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="profileMedication"
                                  value={values.medication}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  Please provide details of client's current medication. If current medication is described in IAR please refer to it.
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Identified risks and agreed management strategies*</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="identifiedRisksAndAgreedManagement"
                                  value={values.identifiedRisksAndAgreedManagement}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  Please provide details about any identified risks and agreed management plans. You can find additional information and a
                                  template in the Centralised Service Clinical Risk Assessment and Management Policy in the Resources tab.
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Centre anticipated end of care*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="estimatedEndOfCareDate"
                                  value={values.estimatedEndOfCareDate}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                              </Form.Group>
                            </Col>
                            {/* <Col md="6">
                      <Form.Group>
                        <Form.Label>Estimated total number of sessions</Form.Label>
                        <Form.Control type="text" name="csSessionExpectation" defaultValue={currentCsSessionExpect} readOnly />
                      </Form.Group>
                    </Col> */}
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>MMHC contact and process expectations*</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="referralInformation"
                                  value={values.referralInformation}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  Please provide details of the contact and process expectations. If current process expectations are described in the IAR,
                                  please refer to it.
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Special Circumstances</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="specialCircumstances"
                                  value={values.specialCircumstances}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                                <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                  Please provide details of any special circumstances. If relevant details are described in the IAR, please refer to it.
                                </Form.Label>
                              </Form.Group>
                            </Col>
                          </Row>
                          <h5>Assessments</h5>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Initial Assessment Status</Form.Label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2rem",
                                  }}
                                >
                                  <span
                                    className="text-muted"
                                    style={{
                                      fontSize: "1rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {values.initalAssessmentOutcome || "Not Set"}
                                  </span>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>IAR Upload Status</Form.Label>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "2rem",
                                  }}
                                >
                                  <span
                                    className="text-muted"
                                    style={{
                                      fontSize: "1rem",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {values.recentIARFileURL || "No Upload"}
                                  </span>
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                        </Tab>
                      ) : null}

                      {values.providerType !== "Financial" && values.providerType !== "Supervision" ? (
                        <Tab eventKey="ClientGP" title="GP" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                          <>
                            {/* Medical Practitioner */}
                            {(values.providerType !== "Provisional" && values.providerType !== "GP") || values.specialisttype === "centralisedservice" ? (
                              <>
                                <Row>
                                  <Col md="4">
                                    <h4>Client's GP</h4>
                                  </Col>
                                  <Col md="2" style={{ textAlign: "right" }}>
                                    <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                                  </Col>
                                  <Col md="6">
                                    <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                      <Autocomplete
                                        id="profileMedicalPractitionerID"
                                        variant="outlined"
                                        options={medicalPractitioners}
                                        getOptionLabel={(option) => option.fullname}
                                        getOptionSelected={(option, value) => getMedicalPractitionerOption(option, value)}
                                        value={values.medicalPractitioner || null}
                                        onChange={(event, newValue) => {
                                          setFieldValue("medicalPractitioner", newValue);
                                          setFieldValue("medicalPractitionerID", newValue ? newValue.id : 0);
                                        }}
                                        style={{
                                          fullWidth: true,
                                          display: "flex",
                                          wrap: "nowrap",
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            type="text"
                                            variant="outlined"
                                            margin="dense"
                                            name="MedicalPractitionerSelector"
                                            style={{
                                              backgroundColor: "",
                                              margin: 0,
                                              padding: 0,
                                            }}
                                            inputProps={{
                                              ...params.inputProps,
                                              autoComplete: "new-password",
                                            }}
                                          />
                                        )}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <hr></hr>
                                <Row>
                                  <Col md="3">
                                    <Form.Group controlId="currentMedicalPractitionerFirstName">
                                      <Form.Label>Firstname</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="firstName"
                                        value={values.medicalPractitioner ? values.medicalPractitioner.firstName : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractitioner", {
                                            ...values.medicalPractitioner,
                                            firstName: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group controlId="currentMedicalPractitionerSurname">
                                      <Form.Label>Surname</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="surname"
                                        value={values.medicalPractitioner ? values.medicalPractitioner.surname : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractitioner", {
                                            ...values.medicalPractitioner,
                                            surname: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group controlId="currentMedicalPractitionerMobilePhone">
                                      <Form.Label>Mobile Phone</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="mobilephone"
                                        value={values.medicalPractitioner ? values.medicalPractitioner.mobilephone : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractitioner", {
                                            ...values.medicalPractitioner,
                                            mobilephone: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group controlId="currentMedicalPractitionerProviderNo">
                                      <Form.Label>Provider Number</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="providernumber"
                                        value={values.medicalPractitioner ? values.medicalPractitioner.providernumber : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractitioner", {
                                            ...values.medicalPractitioner,
                                            providernumber: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                {/* Medical Practice */}
                                <Row>
                                  <Col md="4">
                                    <h4>Practice</h4>
                                  </Col>
                                  <Col md="2" style={{ textAlign: "right" }}>
                                    <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                                  </Col>
                                  <Col md="6">
                                    <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                      <Autocomplete
                                        id="profileMedicalPractice"
                                        variant="outlined"
                                        options={medicalPractices}
                                        getOptionLabel={(option) => option.practicename}
                                        getOptionSelected={(option, value) => getMedicalPracticeOption(option, value)}
                                        value={values.medicalPractice || null}
                                        onChange={(event, newValue) => setFieldValue("medicalPractice", newValue)}
                                        style={{
                                          fullWidth: true,
                                          display: "flex",
                                          wrap: "nowrap",
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            type="text"
                                            variant="outlined"
                                            margin="dense"
                                            name="MedicalPracticeSelector"
                                            style={{
                                              backgroundColor: "",
                                              margin: 0,
                                              padding: 0,
                                            }}
                                            inputProps={{
                                              ...params.inputProps,
                                              autoComplete: "new-password",
                                            }}
                                          />
                                        )}
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <hr></hr>
                                <Row>
                                  <Col md="5">
                                    <Form.Group>
                                      <Form.Label>Clinic Name</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="practicename"
                                        value={values.medicalPractice ? values.medicalPractice.practicename : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            practicename: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>ABN</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="currentAbn"
                                        value={values.medicalPractice ? values.medicalPractice.abn : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            abn: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Contact Phone</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="currentPhone"
                                        value={values.medicalPractice ? values.medicalPractice.phone : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            phone: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="6">
                                    <Form.Group>
                                      <Form.Label>Clinic Address</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="currentAddress1"
                                        value={values.medicalPractice ? values.medicalPractice.address1 : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            address1: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Clinic Fax</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="currentFax"
                                        value={values.medicalPractice ? values.medicalPractice.fax : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            fax: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>Clinic Email</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="currentEmail"
                                        value={values.medicalPractice ? values.medicalPractice.email : ""}
                                        onChange={(event) =>
                                          setFieldValue("medicalPractice", {
                                            ...values.medicalPractice,
                                            email: event.target.value,
                                          })
                                        }
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                <Row>
                                  <Col md="4">
                                    <h4>Client's GP</h4>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>GP Name</Form.Label>
                                      <Form.Control type="text" name="gpName" value={values.gpName} onChange={handleChange} autoComplete="new-password" />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>GP Clinic Name</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="gpClinicName"
                                        value={values.gpClinicName}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col md="3">
                                    <Form.Group>
                                      <Form.Label>GP Contact Number</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="gpContactNumber"
                                        value={values.gpContactNumber}
                                        onChange={handleChange}
                                        autoComplete="new-password"
                                      />
                                    </Form.Group>
                                  </Col>
                                  {currentProviderType === "GP" ? (
                                    <Col md="6">
                                      <Form.Group>
                                        <Form.Label>Client consent to share their Mental Health Treatment Plan with their GP</Form.Label>
                                        <Form.Control as="select" name="consentToShareWithGP" value={values.consentToShareWithGP} onChange={handleChange}>
                                          <option value=""></option>
                                          <option value="N">No</option>
                                          <option value="Y">Yes</option>
                                        </Form.Control>
                                      </Form.Group>
                                    </Col>
                                  ) : null}
                                </Row>
                              </>
                            )}
                          </>
                        </Tab>
                      ) : null}

                      <Tab
                        eventKey="Notes"
                        title="Notes"
                        style={{
                          backgroundColor: "rgb(245, 245, 245)",
                          padding: 6,
                        }}
                      >
                        <Notes
                          type="Client"
                          pkid={values.id}
                          firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                          medicalPractice={currentMedicalPractice}
                          waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                          faxGP={values.referralGPPracticeFax}
                          ownerName={values.ownerFirstName}
                          specialistType={values.specialisttype}
                          email={values.email}
                          mobilephone={values.mobilephone}
                          providerTotal={values.providerTotal}
                          viewType="NoteOnly"
                        />
                      </Tab>
                      <Tab eventKey="ClientScores" title="Scores" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <ClientScores clientID={values.id} />
                      </Tab>
                      <Tab eventKey="Communications" title="Communications" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <Notes
                          type="Client"
                          pkid={values.id}
                          firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                          waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                          faxGP={values.referralGPPracticeFax}
                          ownerName={values.ownerFirstName}
                          specialistType={values.specialisttype}
                          email={values.email}
                          mobilephone={values.mobilephone}
                          providerTotal={values.providerTotal}
                          viewType="CommunicationOnly"
                        />
                      </Tab>
                      <Tab eventKey="files" title="Files" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <Files type="Client" subtype={values.paymentType} pkid={values.id} specialistType={values.specialisttype} />
                      </Tab>
                      {currentProviderType !== "Financial" && currentProviderType !== "GP" ? (
                        <Tab
                          eventKey="referrals"
                          title="Referrals"
                          style={{
                            backgroundColor: "rgb(245, 245, 245)",
                            padding: 6,
                          }}
                        >
                          <ReferralMaintenance
                            viewerFullName={`${values.firstname} ${values.surname}`}
                            clientID={values.id}
                            psychologistID={registered && registered.id}
                            type={"client"}
                          />
                        </Tab>
                      ) : null}
                    </Tabs>
                    {Object.keys(errors).length > 0 && (
                      <div
                        style={{
                          backgroundColor: "#f8d7da",
                          border: "1px solid #f5c2c7",
                          borderRadius: "6px",
                          padding: "12px 16px",
                          margin: "12px 0",
                          color: "#842029",
                        }}
                      >
                        <strong>Please fix the following errors:</strong>
                        <ul style={{ marginBottom: 0, marginTop: "8px" }}>
                          {Object.entries(errors).map(([field, message]) => (
                            <li key={field}>
                              <strong>{fieldLabels[field] || field}:</strong> {message}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer className="editprofile-modal">
                    <Button variant="secondary" onClick={() => setShow(false)}>
                      Cancel
                    </Button>
                    <Button variant="primary" type="button" onClick={handleSubmit}>
                      Save
                    </Button>
                  </Modal.Footer>
                </form>
              );
            }}
          </Formik>
        </Modal>

        <Modal
          show={showCancelProviderBooking}
          onHide={() => setShowCancelProviderBooking(false)}
          dialogClassName="new-bookingDialog-modal"
          style={{ zIndex: 1150 }}
          centered
        >
          <Modal.Header closeButton className="new-booking-modal">
            <Modal.Title>Booking with {booking.clientfullname}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
            <Grid container spacing={3}>
              <Grid item md={3} xs={6}>
                Client:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.clientfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Date:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
              </Grid>
              <Grid item md={3} xs={6}>
                Time:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
              </Grid>
              <Grid item md={3} xs={6}>
                Payment Type:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.paymentType}
              </Grid>
              <hr />
              <Grid item md={12} xs={6}>
                <Form.Group>
                  <Form.Label style={{ fontWeight: 600, paddingBottom: 10 }}>Why is this booking being cancelled?</Form.Label>
                  <Form.Check id="cancellationType-NoShow" name="noShowCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="NoShow"
                      type="radio"
                      checked={cancellationType === "NoShow" ? true : false}
                      onChange={(e) => setCancellationType("NoShow")}
                    />
                    <Form.Check.Label style={{ marginLeft: 12 }}>Client did not attend </Form.Check.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-LateCancel" name="LateCancelCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="LateCancel"
                      type="radio"
                      checked={cancellationType === "LateCancel" ? true : false}
                      onChange={(e) => setCancellationType("LateCancel")}
                    />
                    <Form.Check.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Client </Form.Check.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-Provider24" name="providerCancellation24" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="providerCancellation24"
                      type="radio"
                      checked={cancellationType === "LateCancelProvider" ? true : false}
                      onChange={(e) => setCancellationType("LateCancelProvider")}
                    />
                    <Form.Label style={{ marginLeft: 12 }}>Cancellation within 24 hours by Provider</Form.Label>
                  </Form.Check>
                  <Form.Check id="cancellationType-Provider" name="providerCancellation" type="radio" style={{ marginBottom: 8 }}>
                    <Form.Check.Input
                      name="providerCancellation"
                      type="radio"
                      checked={cancellationType === "Provider" ? true : false}
                      onChange={(e) => setCancellationType("Provider")}
                    />
                    <Form.Label style={{ marginLeft: 12 }}>Cancelled</Form.Label>
                  </Form.Check>

                  {cancellationType !== "" ? (
                    <>
                      {cancellationType === "NoShow" ? (
                        <Form.Label style={{ marginLeft: 12 }}>To cancel please enter information relating to the Client not attending</Form.Label>
                      ) : (
                        <Form.Label style={{ marginLeft: 12 }}>To cancel please enter the reason for cancellation</Form.Label>
                      )}
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="cancellationReason"
                        value={cancellationReason}
                        onChange={(event) => setCancellationReason(event.target.value)}
                        autoComplete="new-password"
                      />
                      {cancellationType === "NoShow" ? (
                        <>
                          <Checkbox
                            aria-label="Send Cancellation SMS"
                            name="cancellationSMS"
                            value={cancellationTypeSMS}
                            onChange={(event) => updateCancellationTypeSMS(event.target.checked)}
                            style={{ paddingTop: 6, paddingLeft: 0 }}
                          />
                          <Form.Label style={{ marginLeft: 12 }}>Do you want to SMS the Client not attending</Form.Label>
                        </>
                      ) : null}
                      {cancellationTypeSMS ? (
                        <>
                          <Form.Label style={{ marginLeft: 12 }}>Please enter the SMS message</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={5}
                            name="cancellationTypeSMSText"
                            value={cancellationTypeSMSText}
                            onChange={(event) => setCancellationTypeSMSText(event.target.value)}
                            autoComplete="new-password"
                          />
                        </>
                      ) : null}
                    </>
                  ) : null}
                </Form.Group>
              </Grid>
            </Grid>
          </Modal.Body>
          <Modal.Footer className="new-booking-modal">
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item>
                <Button variant="secondary" size="sm" onClick={() => setShowCancelProviderBooking(false)} className="lightButtonOutlinedLarge">
                  Close
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => cancelBooking(booking.id)}
                  disabled={!cancellationReason || (cancellationReason && cancellationReason.replace(/\s/g, "").length < 5)}
                  className="lightButtonOutlinedLarge"
                >
                  Cancel Booking &gt;
                </Button>
              </Grid>
            </Grid>
          </Modal.Footer>
        </Modal>
      </FormElement>
    );
  };

  const isBooking = props.valueGetter("eventType") === undefined || props.valueGetter("eventType") === "booking";

  if (isBooking) {
    return renderBookingForm(props);
  }
};
